import type { UploadResponse, UploadType } from '~/types/types'

export const useUploadRepository = () => {
  const api = useApi()

  const upload = async (file: File, type: UploadType, id?: number): Promise<{ url: string, path?: string, name?: string }> => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', type)

    if (typeof id === 'number') {
      formData.append('fk', String(id))
    }

    const response = await api.post<UploadResponse, FormData>('/api/upload', { body: formData })
    return { url: response.data.url, path: response.data.path, name: response.data.name }
  }

  const destroy = async (path: string, disk: 'minio_private' | 'minio_public' = 'minio_private') => {
    return api.del<{ message: string }>('/api/upload', {
      query: { path, disk }
    })
  }

  return {
    upload,
    destroy
  }
}
